import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './connections.less';
import { connectIntegration, disconnectIntegration } from '../../redux/actions/integrationsConnectionActions';
import clioIcon from './icons/clio.png';
import ClioAuthenticator from "./ClioAuthenticator";
import { notify } from 'common/Notification';

class ClioSwitch extends Component {
  static defaultProps = {
    connectionId: null,
  };

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    connectionId: PropTypes.number,
    agreedToPricing: PropTypes.bool.isRequired,
  };

  state = {
    loading: false,
  };

  onClick = () => {
    const { connectionId } = this.props;

    if (connectionId === null) {
      this.setState({ loading: true});
      ClioAuthenticator()
        .login({
          // TODO adjust scopes to minimum required
          scope: 'full',
          state: { redirect_host: window.location.host }
        })
        .then(
          ({ authResponse }) => {
            this.props.dispatch(connectIntegration('files', 'clio', authResponse));
            this.setState({ loading: false });
          },
          (res) => {
            const { code, message } = res.error;
            this.setState({ loading: false });
            notify.error(`Error connecting to Clio: [${code}] ${message || ''}`);
          }
        )
    } else {
      this.props.dispatch(disconnectIntegration(connectionId));
    }
  }

  render() {
    const { connectionId, agreedToPricing } = this.props;
    const iconCls = `kloudless-switch ${connectionId ? 'on' : ''} ${agreedToPricing ? '' : 'hidden'}`;

    return (
      <div className="kloudless-control-holder2" >
        <img className="kloudless-connection-icon"
             src={clioIcon} TODO
             alt="Clio logo"
        />

        <div className={iconCls} onClick={this.onClick} >
          { this.state.loading
          && <i
            className={"fa fa-circle-o-notch fa-spin"}
            style={{ marginTop: '10px', marginLeft: '11px', fontSize: '11px' }}

          />}
        </div>
      </div>
    );
  }
}

export default ClioSwitch;



// WEBPACK FOOTER //
// ./src/Integrations/connections/ClioSwitch.jsx